import actions from "./actions";
import mutations from "./mutations";

const state = {
  start_year: null,
  end_year: null,
  res_list_shu: [],
  res_chartshu: [],
  res_fileshu: null
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
